module.exports = __webpack_public_path__ + "media/Env_Strings.4202bf01.mp3";